import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";
import { OverviewDetailedViewModel } from "@common/components/overviewStepSection/OverviewStepSection.types";
import { AllLegalEntityInfoProps } from "./AllLegalEntityInfo";

export function useAllLegalEntityInfo(props: AllLegalEntityInfoProps) {
    const url = `/LegalEntity/${props.legalEntityId}/overview/extended-legal-entity-details`;
    const { isLoading, data } = useDotLegalQuery<OverviewDetailedViewModel>(url);

    return {
        isLoading,
        data,
    };
}
